import { useForm, useFormContext } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, TextField as MuiTextField, MenuItem, Select, Box, Checkbox } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { DischargeSummaryMedicineDetailsForm } from '../../HMS/transactions/DischargeSummaryMedicineDetailsForm';
import { DischargeSummaryAddDiagnosForm } from '../../HMS/transactions/DischargeSummaryAddDiagnosForm';
import { OPDBillingDetailForm } from '../../HMS/transactions/OPDBillingDetailForm';
import AddIcon from '@mui/icons-material/Add';


const PATIENT_TABLE_HEADER = [
    { header: 'UHID', accessor: 'uhid' },
    { header: 'OP No', accessor: 'op_no' },
    { header: 'Created At', accessor: 'createdAt' },
    { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
    { header: 'Mobile No', accessor: 'address.mobile' },
    { header: 'Doctor', accessor: 'consultant.name' },
    { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
    {
        header: ' Date',
        accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
    },
    {
        header: 'UHID No',
        accessor: 'uhid'
    },
    {
        header: 'Patient Name',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row?.patient?.name}`}
                </span>
            );
        },
    },
    {
        header: 'Sponsor',
        accessor: 'patient.sponsor'
    },
    {
        header: 'Mobile No',
        accessor: 'patient.mobile_no'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];

const Product_Details = [
    {
        header: 'Bill No.',
        accessor: (row) => row.complaints
    },
    {
        header: 'Bill Date',
        accessor: "createdAt"
    },
    {
        header: 'Debit',
        accessor: "createdAt"
    },
    {
        header: 'Credit.',
        accessor: "createdAt"
    },
    {
        header: 'Action.',
        accessor: "createdAt"
    },
]

const initialOPDBillingDataObj = {
    data: [],
    loading: false
};

export const BillWiseLedgerOpeningBalance = () => {
    const doctorIDRef = useRef();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
    const [patientDetailList, setPatientDetailList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [complaints, setComplaints] = useState([])
    const [departmentDropdown, setDepartmentDropdown] = useState([]);
    const [medicineDetailList, setmedicineDetailList] = useState([]);
    const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
    const [addDiagnosDialogOpen, setAddDiagnosDialogOpen] = useState(false);
    const [diagnos, setDiagnos] = useState([])
    const [addMedicineDialogue, setAddMedicineDialogue] = useState(false);
    const [patientVitals, setPatientVitals] = useState([]);
    const [input, setInput] = useState('')
    const [originalData, setOriginalData] = useState([])
    const [isFiltered, setIsFiltered] = useState(false)
    const [pastComplaints, setPastComplaints] = useState([])
    const [pastDiagnos, setPastDiagnos] = useState([])
    const [pastService, setPastService] = useState([])
    const [pastMedicine, setPastMedicine] = useState([])

    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        const dayDifference = today.getDate() - birthDate.getDate();
        if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
            age--;
        }
        return age;
    }

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                uhid: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: getCurrentDateTime('time'),
            bill: {
                out_sourced: 'No',
                rec_amt_1: 0,
                rec_amt_2: 0,
                tds_amt: 0,
                disc_amt: 0,
                gst_amt: 0,
                net_amt: 0
            }
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const getDepartmentDropdown = useCallback(async () => {
        const data = await dropdownFetch('department');
        setDepartmentDropdown(data);
    }, []);

    useEffect(() => {
        getDepartmentDropdown();
    }, getDepartmentDropdown)

    useEffect(() => {
        let total_qty = 0;
        let total_amt = 0;
        let disc_amt = 0;
        let net_amt = 0;
        let gst_amt = 0;
        detailList.forEach((detail) => {
            total_qty += detail.quantity;
            total_amt += detail.amount;
            disc_amt += detail.disc_amt;
            gst_amt += detail.gst_amt;
            net_amt += detail.net_amt;
        });
        setValue('bill.total_qty', total_qty);
        setValue('bill.total_amt', total_amt);
        setValue('bill.disc_amt', disc_amt);
        setValue('bill.gst_amt', gst_amt);
        setValue('bill.net_amt', net_amt);
    }, [detailList, setValue]);

    const netAmtWatch = watch('bill.net_amt');
    const recAmt1Watch = watch('bill.rec_amt_1');
    const recAmt2Watch = watch('bill.rec_amt_2');
    useEffect(() => {
        const total_recpt = +recAmt1Watch + +recAmt2Watch;
        setValue('bill.total_recpt', total_recpt);
        setValue('bill.balance_amt', netAmtWatch - total_recpt);
    }, [netAmtWatch, recAmt1Watch, recAmt2Watch, setValue]);

    useEffect(() => {
        if (selectedRecord) {
            const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
                '__v',
                '_id',
                'createdAt',
                'status',
                'service_items',
                'uhid',
                'complaints',
                'diagnos',
                'medicine',
                'vital'
            ]);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
            setValue('uhid', selectedRecord.uhid);
            setDetailList(selectedRecord.service_items);
            setComplaints(selectedRecord.complaints)
            setDiagnos(selectedRecord.diagnos)
            setmedicineDetailList(selectedRecord.medicine)
            setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
            setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
            searchPatientHandler(selectedRecord.uhid);
            if (selectedRecord?.vital) {
                setValue('vital.bp_sys', selectedRecord?.vital.bp_sys)
                setValue('vital.diastol', selectedRecord?.vital.diastol)
                setValue('vital.abdomen', selectedRecord?.vital.abdomen)
                setValue('vital.pulse', selectedRecord?.vital.pulse)
                setValue('vital.dm', selectedRecord?.vital.dm)
                setValue('vital.ihd', selectedRecord?.vital.ihd)
                setValue('vital.con_level', selectedRecord?.vital.con_level)
                setValue('vital.temp', selectedRecord?.vital.temp)
                setValue('vital.weight', selectedRecord?.vital.weight)
                setValue('vital.resp_rate', selectedRecord?.vital.resp_rate)
                setValue('vital.chest', selectedRecord?.vital.chest)
                setValue('vital.cvs', selectedRecord?.vital.cvs)
                setValue('vital.dre', selectedRecord?.vital.dre)
                setValue('vital.cns', selectedRecord?.vital.cns)
                setValue('vital.any_other', selectedRecord?.vital.any_other)
                setValue('vital.allergies', selectedRecord?.vital.allergies)
                setValue('vital.height', selectedRecord?.vital.height)
                setValue('vital.blood_group', selectedRecord?.vital.blood_group)
                setValue('vital.pallor', selectedRecord?.vital.pallor)
                setValue('vital.cyanos', selectedRecord?.vital.cyanos)
                setValue('vital.jvp', selectedRecord?.vital.jvp)
                setValue('vital.lymphade', selectedRecord?.vital.lymphade)
                setValue('vital.hydration', selectedRecord?.vital.hydration)
                setValue('vital.asthma', selectedRecord?.vital?.asthma)
                setValue('vital.icterus', selectedRecord?.vital?.icterus)
                setValue('vital.clubbing', selectedRecord?.vital?.clubbing)
                setValue('follow_up_date', selectedRecord?.follow_up_date)
                setValue('follow_up_days', selectedRecord?.follow_up_days)
                setValue('advice', selectedRecord?.advice)
                setValue('remarks', selectedRecord?.remarks)
            }
        } else {
            reset();
        }
    }, [selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/opd-requisition-edit' : '/opd-requisition-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: { ...formValues, service_items: detailList, complaints: complaints, medicine: medicineDetailList, diagnos: diagnos },
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} OPD Requisition`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            reset();
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} OPD Requisition`, {
                variant: 'error'
            });
        }
        setLoading(false);
    };

    const handleRowDelete = (rowId) => {
        setDetailList((prev) => prev.filter((data) => {
            return data.service !== rowId;
        }));
    };

    const handleComplaintDelete = (rowId) => {
        setComplaints((prev) => prev.filter((data) => {
            return data.complaints != rowId
        }))
    }

    const handleDiagnosDelete = (rowId) => {
        setDiagnos((prev) => prev.filter((data) => {
            return data.add_diagnos != rowId
        }))
    }

    const handleDeleteMedicine = (rowId) => {
        setmedicineDetailList((prev) => prev.filter((data) => {
            return data.medicine_name != rowId
        }))
    }

    const onDetailAddHandler = (data) => {
        if (detailList.some((detail) => detail.service === data.service)) {
            toast('Same service already taken.', { variant: 'error' });
        } else {
            setDetailList((prev) => [...prev, { ...data }]);
        }
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/opd-requisition-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted OPD Requisition', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete OPD Requisition', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/opd-requisition-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully cancel OPD Requisition', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to cancel OPD Requisition', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setOpdBillingDataObj({ loading: true });
        const response = await request('/opd-requisition-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const filteredData = sortedData.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setOpdBillingDataObj({ loading: false, data: filteredData });
            setOriginalData(filteredData)
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setOpdBillingDataObj({ loading: false });
        }
    };

    const handleAddDetailsWindow = async () => {
        setAddDetailsDialogOpen(true);
        setOpdBillingDataObj({ loading: true });
        const response = await request('/opd-requisition-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const filteredData = sortedData.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setOpdBillingDataObj({ loading: false, data: filteredData });
            setOriginalData(filteredData)
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setOpdBillingDataObj({ loading: false });
        }
    };

    const searchPatientHandler = async (uhid = null) => {
        if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
        setLoading(true);
        const today = new Date().toISOString().split('T')[0];
        if (!uhid) setSearchPatientRegisterationDialog(true);
        const response = await request('/patient-registeration-searchdetail', {
            method: 'GET',
            query: { uhid }
        });
        if (response?.success) {
            if (uhid) {
                const {
                    data: [patientData],
                } = response;
                setValue('visit', patientData.visit_no);
                setValue('op', patientData.op_no);
                setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
                setValue('patient_suffix', patientData.name_suffix);
                setValue('opd_type', patientData.opd_type?.type);
                setValue('ref_type', patientData.ref_by?.referral_name);
                setValue('application_no', patientData.app_no_date);
                setValue('doctor', patientData.consultant?.name);
                doctorIDRef.current = patientData.consultant?._id;
                setValue('department', patientData.department?.department);
                setValue('patient_age', calculateAge(patientData?.dob));
                setValue('sponsor', patientData.sponsor?.name);
                setValue('remarks', patientData.remarks);
                setValue('queue_no', patientData.app_no_date);
                setValue('card_no', patientData.chq_card_no);
                setValue('vertical', patientData.vertical?.verticalname);
            } else {
                const todayData = response.data.filter(patient =>
                    new Date(patient.createdAt).toISOString().split('T')[0] === today
                );
                setPatientDetailList(todayData);
            }
        } else {
            toast('Failed to load patient details', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleActiveTab = (newTabIndex) => {
        setActiveTab(newTabIndex);
    };

    useEffect(() => {
        if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
            setOriginalData(opdBillingDataObj.data);
            setIsFiltered(false);
        }
    }, [opdBillingDataObj.data]);

    const handleUhidSearch = () => {
        const lowercasedInput = input.toLowerCase();
        console.log("HELLO BILLING DATA OBJ", opdBillingDataObj)
        const filtered = opdBillingDataObj.data.filter((item) =>
            item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
            item?.patient?.name?.toLowerCase().includes(lowercasedInput) ||
            item?.patient?.mobile_no?.toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleUhidSearch();
    };


    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
                <Container
                    sx={{
                        mt: 2,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 3,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                                Bill Wise Ledger Opening Balance
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                {/* <CustomButtonn
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}/ProgressReport?refId=${selectedRecord._id}`, '_blank')}
                                >
                                    Progress Report
                                </CustomButtonn> */}
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    disabled={['new', 'edit'].includes(currentAction)}
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={'Exit'}
                                    variant="contained"
                                    onClick={() => { setCurrentAction(''); }}
                                >
                                    Exit
                                </CustomButtonn>
                            </Stack>
                        </Stack>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sx={{ display: 'flex', gap: 0.7, flexDirection: 'column' }}>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem', }}>Doc No.</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                        sx={{ flex: 0.8 }} name="doc_no" placeholder="" />
                                </Stack>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Doc Date</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                        sx={{ flex: 0.8 }} placeholder="" name="date" type="date" />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} sx={{ display: 'flex', gap: 0.7, flexDirection: 'column' }}>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem', }}>Suppllier Name</Typography>
                                    <SelectTag disabled={!['new', 'edit'].includes(currentAction)}
                                        formControlSX={{ flex: 0.8 }} name="suppllier_name" placeholder="" />
                                </Stack>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Remarks</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                                        sx={{ flex: 0.8 }} placeholder="" name="remarks"
                                        disabled={!['new', 'edit'].includes(currentAction)} />
                                </Stack>
                            </Grid>

                            <Grid item xs={12} sx={{ minHeight: '45rem' }}>
                                <Stack spacing={0.5} sx={{ flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Button
                                            disabled={['new', 'edit'].includes(currentAction)}
                                            id={`${lastPathSegment}Read`}
                                            variant="contained"
                                            onClick={handleAddDetailsWindow}
                                        >
                                            Add Details
                                        </Button>
                                    </Box>
                                    <Box sx={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}>
                                        <Table
                                            data={pastComplaints?.complaints || []}
                                            columns={Product_Details}
                                            size="small"
                                            onDeleteHandler={handleRowDelete}
                                        />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Container>
            </Paper >


            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        OPD Requisition Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '1.4rem' // Adjust input font size
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Patient"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_HEADER}
                    data={originalData || []}
                    loading={opdBillingDataObj.loading}
                    onRowClick={(row) => {
                        delete row.patient;
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
            <Dialog
                open={addDetailsDialogOpen}
                onClose={() => setAddDetailsDialogOpen(false)}
                PaperProps={{ sx: { width: '65%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0.5}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="2px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Bill Wise Ledger Opening Add Details Window
                    </Typography>
                    <IconButton onClick={() => setAddDetailsDialogOpen(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <FormProvider methods={methods} sx={{ mt: 1.5 }} direction="row" spacing={2} alignItems="center" justifyContent="center" >
                    <Grid container spacing={1}>
                        <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                                <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill No.</Typography>
                                <TextField sx={{ flex: 0.6 }} name="bill_no" placeholder="bill no." />
                            </Stack>
                            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                                <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Debit Amount</Typography>
                                <TextField sx={{ flex: 0.6 }} name="debit_amount" placeholder="debit amount" type="number" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                                <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Date</Typography>
                                <TextField sx={{ flex: 0.6 }} name="bill_date" placeholder="bill date" />
                            </Stack>
                            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                                <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Credit Amount</Typography>
                                <TextField sx={{ flex: 0.6 }} name="crebit_amount" placeholder="crebit amount" type="number" />
                            </Stack>
                        </Grid>
                        <Grid item xs={8} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                            <Stack spacing={5} direction="row" alignItems="center" justifyContent="flex-end">
                                <Button variant="contained" type="submit"
                                >
                                    Add
                                </Button>
                                <Button color="error" variant="contained"
                                    onClick={() => setAddDetailsDialogOpen(false)}
                                >
                                    Close
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Dialog>
        </>
    );
};
